import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { criteriaModalMessages as messages } from "../../../orchestrator.messages";

interface RangeInputProps {
  minValue: number;
  maxValue: string;
  onMinChange: (value: number) => void;
  onMaxChange: (value: string) => void;
}

export function RangeInput({ minValue, maxValue, onMinChange, onMaxChange }: RangeInputProps) {
  const intl = useIntl();

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block font-medium text-gray-700 mb-1">
          <FormattedMessage {...messages.min} />
        </label>
        <input
          type="number"
          min={1}
          value={minValue}
          onChange={e => onMinChange(parseInt(e.target.value, 10) || 1)}
          className="w-full border rounded px-3 py-2"
        />
      </div>
      <div>
        <label className="block font-medium text-gray-700 mb-1">
          <FormattedMessage {...messages.maxOptional} />
        </label>
        <input
          type="number"
          min={minValue}
          value={maxValue}
          onChange={e => onMaxChange(e.target.value)}
          placeholder={intl.formatMessage(messages.noLimit)}
          className="w-full border rounded px-3 py-2"
        />
      </div>
    </div>
  );
}
